<template>
    <div class="home-admin-content">
        <!-- Header da página -->
        <PageHeader
            title="Painel de Controle de Veículos"
            icon="fas fa-tachometer-alt"
            sub-title="Gerencie e monitore toda sua frota em tempo real"
        />

        <!-- Cards de métricas redesenhados -->
        <div class="metrics-section">
            <div class="info-cards-grid">
                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'patio' }"
                    @click="getVehicles('patio')"
                >
                    <div class="card-icon available-icon">
                        <i class="fas fa-parking"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">No Pátio</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.available }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'reserva_do_dia' }"
                    @click="getVehicles('reserva_do_dia')"
                >
                    <div class="card-icon today-icon">
                        <i class="fas fa-calendar-day"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Reservas do Dia</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.reservationsToday }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'pendencia' }"
                    @click="getVehicles('pendencia')"
                >
                    <div class="card-icon pending-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Pendências</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.pendencies }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'retirado' }"
                    @click="getVehicles('retirado')"
                >
                    <div class="card-icon progress-icon">
                        <i class="fas fa-car-side"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Retirados</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.retreat }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'devolvido' }"
                    @click="getVehicles('devolvido')"
                >
                    <div class="card-icon completed-icon">
                        <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Devolvidos</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.devolved }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'pre_reserva' }"
                    @click="getVehicles('pre_reserva')"
                >
                    <div class="card-icon pre-reserve-icon">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Pré-reservas</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.preReserves }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>

                <div
                    class="info-card metric-card"
                    :class="{ 'card-active': selectedMenu === 'bloqueado' }"
                    @click="getVehicles('bloqueado')"
                >
                    <div class="card-icon blocked-icon">
                        <i class="fas fa-ban"></i>
                    </div>
                    <div class="card-content">
                        <div class="card-label">Bloqueados</div>
                        <div
                            class="card-value"
                            v-if="count.loaded"
                        >{{ values.blocked }}
                        </div>
                        <div
                            v-else
                            class="card-loading"
                        >
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Painel principal -->
        <div class="main-panel-section">
            <div class="card">
                <!-- Header com controles -->
                <div class="panel-header">
                    <div class="panel-title">
                        <i class="fa fa-cars mr-2"></i>
                        Gerenciamento de Veículos
                    </div>
                    <div class="panel-actions">
                        <button
                            @click="filter()"
                            class="btn btn-primary btn-action"
                            :disabled="!count.loaded"
                        >
                            <i class="fas fa-sync-alt"></i>
                            Atualizar
                        </button>
                        <button
                            class="btn btn-outline-primary btn-action"
                            data-toggle="collapse"
                            href="#filterCars"
                            aria-expanded="false"
                            aria-controls="filterCars"
                        >
                            <i class="fas fa-filter"></i>
                            Filtros
                        </button>
                    </div>
                </div>

                <!-- Filtros colapsáveis -->
                <div
                    class="collapse"
                    id="filterCars"
                >
                    <div class="filters-section">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="branch">
                                        <span class="required">*</span>
                                        Filial
                                    </label>
                                    <v-select
                                        :options="branches"
                                        label="description"
                                        :reduce="(branch) => branch.id"
                                        placeholder="Selecione uma Filial"
                                        class="style-chooser-home"
                                        v-model="home.branch_id"
                                    >
                                        <template slot="no-options">
                                            Nenhuma filial encontrada
                                        </template>
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="branch">
                                        <span class="required">*</span>
                                        Centro de Custo
                                    </label>
                                    <v-select
                                        :options="costCenters"
                                        label="description"
                                        :reduce="(costCenter) => costCenter.id"
                                        placeholder="Selecione um Centro de Custo"
                                        class="style-chooser-home"
                                        v-model="home.cost_center_id"
                                    >
                                        <template slot="no-options">
                                            Nenhum centro de custo encontrado
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button
                                    type="button"
                                    @click="filter"
                                    class="btn btn-primary"
                                >
                                    <i class="fas fa-search mr-2"></i>
                                    Filtrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <!-- Informação sobre o filtro atual -->
                    <div
                        v-if="selectedMenu"
                        class="current-filter-info"
                    >
                        <div class="alert alert-info">
                            <i class="fas fa-info-circle mr-2"></i>
                            <strong>{{ textInfos[selectedMenu] }}</strong>
                        </div>
                    </div>

                    <!-- Grid de veículos -->
                    <div
                        v-if="filteredVehicles.length > 0"
                        class="vehicles-grid"
                    >
                        <div
                            :key="'vehicle' + v.id + i"
                            v-for="(v, i) in filteredVehicles"
                            class="vehicle-card-wrapper"
                        >
                            <div
                                v-if="selectedMenu !== 'pendencia' && selectedMenu !== 'reserva_do_dia' && selectedMenu !== 'pre_reserva'"
                                :class="v.dash_status"
                                class="vehicle-card-container"
                            >
                                <a
                                    @click="openModals(v.id, v.dash_status, v)"
                                    class="vehicle-link"
                                >
                                    <VehicleCard
                                        :vehicle="v"
                                        :type="activeType"
                                    />
                                </a>
                            </div>

                            <!-- Lógica similar para pendências e reservas do dia... -->
                            <div
                                v-else-if="selectedMenu === 'pendencia'"
                                :class="v.dash_status"
                                class="vehicle-card-container"
                            >
                                <a
                                    @click="getPendency(v.id, v.vehicles.id)"
                                    class="vehicle-link"
                                >
                                    <VehicleCard
                                        :vehicle="v.vehicles"
                                        :type="activeType"
                                    />
                                </a>
                            </div>

                            <div
                                v-else-if="selectedMenu === 'reserva_do_dia' || selectedMenu === 'pre_reserva'"
                                :class="v.dash_status"
                                class="vehicle-card-container"
                            >
                                <a
                                    @click="getReserveTodayData(v.reserve_vehicle[0].id, v.id)"
                                    class="vehicle-link"
                                >
                                    <VehicleCard
                                        :vehicle="v"
                                        :type="activeType"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Estados vazios e carregamento -->
                    <div
                        v-if="!count.loadedVehicles"
                        class="loading-state"
                    >
                        <div class="loading-spinner">
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                        <div class="loading-text">Carregando veículos...</div>
                    </div>

                    <div
                        v-else-if="filteredVehicles.length == 0"
                        class="empty-state"
                    >
                        <div class="empty-icon">
                            <i class="fas fa-car"></i>
                        </div>
                        <div class="empty-title">Nenhum veículo encontrado</div>
                        <div class="empty-subtitle">
                            Nenhum veículo disponível nas condições selecionadas.
                        </div>
                    </div>

                    <!-- Legenda de cores -->
                    <Legend/>

                </div>
            </div>
        </div>

        <!-- Modais existentes... -->
        <available-modal
            :modalStatus="modalAvailableStatus"
            :dataModal="dataModal"
            @changeModal="changeAvailableModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            v-if="loadModalPatio"
        ></available-modal>

        <locked-modal
            :modalStatus="modalLockedStatus"
            :dataModal="dataModal"
            @changeModal="changeLockedModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            v-if="loadModalBloqueado"
        ></locked-modal>
        <reserved-modal
            :modalStatus="modalReservedStatus"
            :dataModal="dataModal"
            @changeModal="changeReservedModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            @OpenModalUser="openModalUser"
            v-if="loadModalReservado"
        ></reserved-modal>
        <retreat-modal
            :modalStatus="modalRetreatStatus"
            :dataModal="dataModal"
            @changeModal="changeRetreatModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            @OpenModalUser="openModalUser"
            v-if="loadModalRetirado"
        ></retreat-modal>
        <late-modal
            :modalStatus="modalLateStatus"
            :dataModal="dataModal"
            @changeModal="changeLateModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            @OpenModalUser="openModalUser"
            v-if="loadModalAtrasado"
        ></late-modal>
        <devoluted-modal
            :modalStatus="modalDevolutedStatus"
            :dataModal="dataModal"
            @changeModal="changeDevolutedModal"
            @openModals="openModals"
            @OMDCk="openModalCheckin"
            @OpenModalUser="openModalUser"
            @refresh="getCount"
            v-if="loadModalDevolvido"
        ></devoluted-modal>
        <checkin-modal
            :modalStatus="modalCheckinStatus"
            :dataModal="dataModalCheckin"
            @changeModal="changeCheckinModal"
            @openModals="openModals"
            @OpenModalUser="openModalUser"
            @OpenLightbox="openLightbox"
            v-if="loadModalCheckin"
        ></checkin-modal>
        <user-modal
            :modalStatus="modalUserStatus"
            :dataModal="dataModalUser"
            title="Visualizar Usuário"
            @changeModal="changeUserModal"
        ></user-modal>


        <PendencyModal
            :pendency="pendency"
            :title="title"
            @get-paginate="getPaginate"
            @changeModal="changePendencyModal"
            @OMDCk="openModalCheckin"
            @open-user-modal="openModalUser"
            :modalStatus="modalPendencyStatus"
            v-if="loadModalPendency"
        />

        <template>
            <vue-easy-lightbox
                :visible="visible"
                :imgs="imgs"
                @hide="handleHide"
            ></vue-easy-lightbox>
        </template>

        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>
<script>
import AvailableModal from "../Modals/AvailableModal.vue";
import LockedModal from "../Modals/LockedModal.vue";
import RetreatModal from "../Modals/RetreatModal.vue";
import ChecklistModal from "../Modals/Checklist/ChecklistModal.vue";
import UserModal from "../Modals/UserModal.vue";
import DevolutedModal from "../Modals/DevolutedModal.vue";
import LateModal from "../Modals/LateModal.vue";
import Loading from "vue-loading-overlay";
import CardsTotal from "./CardsTotal.vue";
import LoadingImage from "../LoadingImage.vue";
import ReservedModal from "../Modals/ReservedModal.vue";
import PendencyModal from "../Modals/PendencyModal.vue";
import env from '../../config/loadEnv.js';
import {getMessage} from "../../composables/message";
import Legend from "./Legend.vue";
import VehicleCard from "./VehicleCard.vue";
import PageHeader from "../Base/PageHeader.vue";
import {fetchGet} from "../../composables/api";

export default {

    components: {
        PageHeader,
        VehicleCard,
        Legend,
        AvailableModal,
        LockedModal,
        RetreatModal,
        CheckinModal: ChecklistModal,
        UserModal,
        DevolutedModal,
        LateModal,
        Loading,
        CardsTotal,
        LoadingImage,
        ReservedModal,
        PendencyModal
    },

    data() {
        return {
            env,
            imagesLoaded: [],
            title: '',
            activeType: 'patio',
            pendency: {},
            dataModalUser: {},
            isLoading: true,
            fullPage: true,
            imgs: "", // Img Url , string or Array
            visible: false,
            index: 0, // default
            showLightbox: false,
            modalAvailableStatus: false,
            modalReservedStatus: false,
            modalRetreatStatus: false,
            modalLateStatus: false,
            modalDevolutedStatus: false,
            modalPendencyStatus: false,
            modalLockedStatus: false,
            modalUserStatus: false,
            dataModal: [],
            modalCheckinStatus: false,
            dataModalCheckin: {},
            loadModalReservado: false,
            loadModalRetirado: false,
            loadModalAtrasado: false,
            loadModalDevolvido: false,
            loadModalCheckin: false,
            loadModal: false,
            loadModalPatio: false,
            loadModalBloqueado: false,
            loadModalUser: false,
            loadModalPendency: false,
            count: {
                loaded: false,
            },
            values: {
                availableVehicles: null,
                reservationsToday: null,
                reservedVehicles: null,
                retreatVehicles: null,
                devolvedVehicles: null,
                blockedVehicles: null,
                lateVehicles: null,
                preReserveVehicles: null,
                pendencies: null,
                vehicles: null,
            },
            filteredVehicles: [],
            dataVehicle: {},
            home: {
                branch_id: null,
                cost_center_id: null,
            },
            selectedMenu: null,
            branches: [
                {
                    id: null,
                    description: "Todas as filiais",
                },
            ],
            costCenters: [
                {
                    id: null,
                    description: "Todos os centros de custo",
                },
            ],
            checklist_items: [{}],
            checked: [],
            textInfos: {
                patio: 'Veículos disponíveis sem reservas para hoje',
                reserva_do_dia: 'Veículos com reservas agendadas para hoje',
                pendencia: 'Reservas pendentes de Check-in',
                reservado: 'Veículos reservados',
                retirado: 'Veículos com reserva em andamento',
                devolvido: 'Veículos devolvidos',
                bloqueado: 'Veículos indisponíveis para reservas',
                pre_reserva: 'Veículos com reservas futuras',
            }
        }
    },

    methods: {

        getStatusBadgeClass(status) { // getStatusBadgeClass - retorna classe para badge de status
            const statusClasses = {
                'patio': 'badge-available',
                'reservado': 'badge-reserved',
                'retirado': 'badge-progress',
                'devolvido': 'badge-completed',
                'bloqueado': 'badge-blocked',
                'pendencia': 'badge-pending',
                'pre_reserva': 'badge-pre-reserve'
            };
            return statusClasses[status] || 'badge-unknown';
        }
        ,
        handleHide() {
            this.visible = false;
        },

        async filter() {
            const self = this;

            self.isLoading = true;

            self.count.loaded = 0;
            this.selectedMenu = null;

            await Promise.all([
                self.getCount(),
                self.getVehicles('patio')
            ])
        },
        openLightbox(data) {
            this.imgs = [
                data.photo1,
                data.photo2,
                data.photo3,
                data.photo4,
                data.photo5,
                data.photo6,
            ];
            this.index = 1; // index of imgList
            this.show();
        },

        show() {
            this.visible = true;
        },
        changePendencyModal(status) {
            this.modalPendencyStatus = status;
        },
        changeAvailableModal(status) {
            this.modalAvailableStatus = status;
        },
        changeReservedModal(status) {
            this.modalReservedStatus = status;
        },
        changeRetreatModal(status) {
            this.modalRetreatStatus = status;
        },
        changeLateModal(status) {
            this.modalLateStatus = status;
        },
        changeUserModal(status) {
            this.modalUserStatus = status;
        },
        changeLockedModal(status) {
            this.modalLockedStatus = status;
        },
        changeDevolutedModal(status) {
            this.modalDevolutedStatus = status;
        },
        changeCheckinModal(status) {
            this.modalCheckinStatus = status;
        },
        async openModalCheckin(id) {
            console.log('openModalCheckin', id)

            const params = {
                with: [
                    'user',
                    'checkout',
                    'checkin',
                    'vehicle_type_id',
                    'vehicles',
                    'reserve_status',
                    'cityDestination',
                ]
            }
            const reserveData = await fetchGet('reserveVehicles/' + id, params);
            this.dataModalCheckin = {...reserveData.data};

            this.modalPendencyStatus = false;
            this.loadModalCheckin = true;
            this.modalCheckinStatus = true;
        },
        openModalUser(object) {
            this.modalUserStatus = true;
            this.dataModalUser = object;
            this.loadModalUser = true;
        },
        closeModals() {
            this.loadModalReservado = false;
            this.loadModalRetirado = false;
            this.loadModalAtrasado = false;
            this.loadModalDevolvido = false;
            this.loadModalCheckin = false;
            this.loadModalPatio = false;
            this.loadModalUser = false;
            this.loadModalBloqueado = false;
        },

        getReserve(id) {
            const self = this;
            const api = self.$store.state.api + "reserveVehicles?id=" + id;


            return self.$http
                .get(api)
                .then((response) => {

                    return response.data.data.find(res => res.id === id);
                })
        },

        getPaginate(data) {
            this.getDataReserve(data.id, data.vehicle, data.index)
        },

        getReserveTodayData(reserve, vehicle) {
            this.title = 'Detalhes da Reserva';
            this.getDataReserve(reserve, vehicle, 1)
        },

        getPendency(reserve, vehicle) {
            this.title = 'Reserva sem Check-in';
            this.getDataReserve(reserve, vehicle, 1)
        },

        async getDataReserve(id, vehicle, index) {
            const self = this;
            self.isLoading = true;

            if (!index) index = 1;

            try {
                const [result1] = await Promise.all([
                    this.getReserve(id, vehicle, index)
                ]);

                console.log(result1)

                self.pendency = {
                    ...result1,
                }

                this.$forceUpdate();

                self.modalPendencyStatus = true;
                self.loadModalPendency = true;
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
            } finally {
                self.isLoading = false;
            }
        },

        openModals(idVehicle, status, object, page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            const self = this;
            const api = self.$store.state.api + "getInfoVehicle/?page=" + page;

            let reserve_id = null;
            if (object && object.reserve_vehicle && object.reserve_vehicle[0]) {
                reserve_id = object.reserve_vehicle[0].id || object.reserve_vehicle[0];
            } else if (object && object.id) {
                reserve_id = object.id;
            }

            var data = {
                idVehicle: idVehicle,
                reserve_id: reserve_id,
            };

            self.isLoading = true;
            self.$http
                .post(api, data)
                .then((response) => {
                    self.dataVehicle = response.data;

                    if (!page) {
                        self.closeModals();
                    }

                    self.dataVehicle.status = status;

                    if (!self.dataVehicle.board && object && object.board) {
                        self.dataVehicle = {...object, ...self.dataVehicle};
                    }

                    self.dataModal = self.dataVehicle;

                    if (status === "patio") {
                        self.modalAvailableStatus = true;
                        self.loadModalPatio = true;
                    } else if (status === "reservado") {
                        self.modalReservedStatus = true;
                        self.loadModalReservado = true;
                    } else if (status === "retirado") {
                        self.modalRetreatStatus = true;
                        self.loadModalRetirado = true;
                    } else if (status === "atrasado") {
                        self.modalLateStatus = true;
                        self.loadModalAtrasado = true;
                    } else if (status === "devolvido") {
                        self.modalDevolutedStatus = true;
                        self.loadModalDevolvido = true;
                    } else if (status === "bloqueado") {
                        self.modalLockedStatus = true;
                        self.loadModalBloqueado = true;
                    }

                    self.isLoading = false;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                    self.isLoading = false;
                });
        },

        getCount: function () {
            const self = this;
            const api = self.$store.state.api + "homeCount/";

            self.count.loaded = false;

            let fd = new FormData();
            fd.append("branch_id", self.home.branch_id ? self.home.branch_id : '');
            fd.append("cost_center_id", self.home.cost_center_id ? self.home.cost_center_id : '');

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.values = response.data
                    self.isLoading = false;

                    self.count.loaded = true;

                    self.$forceUpdate;
                })
                .catch((error) => {
                    self.$message(null, error, "error");
                });
        },

        getVehicles(type) {
            const self = this;

            if (self.selectedMenu === type) return;

            this.imgs = [];
            this.activeType = type

            self.imagesLoaded = [];
            self.selectedMenu = type;
            self.filteredVehicles = [];
            self.count.loadedVehicles = false;

            let fd = new FormData();
            fd.append("branch_id", self.home.branch_id ? self.home.branch_id : '');
            fd.append("cost_center_id", self.home.cost_center_id ? self.home.cost_center_id : '');
            fd.append("type", type);

            const api = self.$store.state.api + "dashboard-vehicles";

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.filteredVehicles = response.data;
                    self.count.loadedVehicles = true;
                    self.$forceUpdate();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                    self.count.loadedVehicles = true;
                })
        },

        getBranches: function () {
            const self = this;
            const api = self.$store.state.api + "branches/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.branches = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getCostCenters: function () {
            const self = this;
            const api = self.$store.state.api + "cost-centers/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.costCenters = [
                        {
                            id: '-1',
                            description: "Veículos de locação",
                        },
                        ...response.data.data
                    ];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getChecklistItens() {
            const self = this;
            const api = self.$store.state.api + "checklistItems/";

            self.$http
                .get(api)
                .then((response) => {
                    self.checklist_items = response.data.data;
                    self.ciCount = response.data.count;

                    for (let i = 0; i < self.ciCount; i++) {
                        if (
                            self.checklist_items[i].id == 1 ||
                            self.checklist_items[i].id == 3
                        ) {
                            self.checked[i] = true;
                        } else {
                            self.checked[i] = false;
                        }
                    }
                })
                .catch((error) => {
                    console.error(error)
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },

    mounted: function () {
        const self = this;
        self.getChecklistItens();
        self.getCount();
        self.getBranches();
        self.getCostCenters();
        self.getVehicles('patio');

        this.users = this.$store.state.user;
    },
}
</script>

<style scoped>
/* Usando classes CSS existentes e adicionando customizações mínimas */

.home-admin-content {
    padding: 20px;
    background-color: #f8f9fa;
    min-height: 100vh;
}

/* Seção de métricas usando classes info-card existentes */
.metrics-section {
    margin-bottom: 2rem;
}

.info-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
}

/* Estendendo a classe info-card existente para métricas */
.metric-card {
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.metric-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f8981d, #fd7e14);
}

.metric-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(248, 152, 29, 0.15);
}

.card-active {
    transform: translateY(-3px) !important;
    box-shadow: 0 8px 30px rgba(248, 152, 29, 0.25) !important;
    border-left-color: #f8981d !important;
}

/* Ícones específicos para cada tipo */
.available-icon {
    background: linear-gradient(135deg, #28a745, #20c997);
}

.today-icon {
    background: linear-gradient(135deg, #FE8D18, #0056b3);
}

.pending-icon {
    background: linear-gradient(135deg, #dc3545, #c82333);
}

.progress-icon {
    background: linear-gradient(135deg, #fd7e14, #e55100);
}

.completed-icon {
    background: linear-gradient(135deg, #343a40, #212529);
}

.pre-reserve-icon {
    background: linear-gradient(135deg, #8b00c7, #6a0099);
}

.blocked-icon {
    background: linear-gradient(135deg, #6c757d, #495057);
}

.card-loading {
    color: #f8981d;
    font-size: 18px;
}

/* Painel principal */
.main-panel-section {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e2e8f0;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-radius: 12px 12px 0 0;
}

.panel-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
}

.panel-actions {
    display: flex;
    gap: 10px;
}

.btn-action {
    min-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

/* Seção de filtros */
.filters-section {
    padding: 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e2e8f0;
}

/* Info do filtro atual usando alert existente */
.current-filter-info {
    margin-bottom: 20px;
}

/* Grid de veículos */
.vehicles-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.vehicle-card-wrapper {
    transition: all 0.3s ease;
}

.vehicle-link {
    text-decoration: none;
    color: inherit;
    display: block;
}

.vehicle-card:hover .vehicle-image {
    transform: scale(1.05);
}

/* Estados de loading e vazio usando classes existentes */
.loading-state, .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.loading-spinner, .empty-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 2rem;
    color: #6c757d;
}

.loading-spinner i {
    color: #f8981d;
}

.loading-text, .empty-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
}

.empty-subtitle {
    color: #6c757d;
    font-size: 1rem;
}

/* Responsividade */
@media (max-width: 768px) {
    .home-admin-content {
        padding: 15px;
    }

    .info-cards-grid {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 10px;
    }

    .panel-header {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .panel-actions {
        justify-content: center;
    }

    .vehicles-grid {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 15px;
    }

}

@media (max-width: 576px) {
    .info-cards-grid {
        grid-template-columns: 1fr;
    }

    .vehicles-grid {
        grid-template-columns: 1fr;
    }

    .panel-actions {
        flex-direction: column;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Report/HomeAdmin.vue